import React from "react";
import { Container } from "./styles";

const EmptyTableMessage: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default EmptyTableMessage;
